import { OrganizationTableItem } from 'types/organizations_table'

// export const createOnboardingChecklistItem = (deal: OrganizationTableItem) => {
//   const onboardingChecklist = [
//     { key: 'checklistSent', name: 'Checklist Sent (Dependency checklist email)', role: 'PM', dependencies: [] },
//     { key: 'receivedDependencies', name: 'Received Dependencies', role: 'PM', dependencies: ['checklistSent'] },
//     {
//       key: 'verifyDependencies',
//       name: 'Verify Dependencies',
//       role: 'PM',
//       dependencies: ['checklistSent', 'receivedDependencies'],
//     },
//     { key: 'gscAccess', name: 'GSC Access', role: 'PM', dependencies: ['checklistSent'] },
//     { ...(deal?.containsSEO && { key: 'gbpAccess', name: 'GBP Access', role: 'PM', dependencies: ['checklistSent'] }) },
//     {
//       ...(deal?.containsSEO && {
//         key: 'completeSeoForm',
//         name: 'SEO Form Completed',
//         role: 'PM',
//         dependencies: ['checklistSent'],
//       }),
//     },
//     {
//       ...(deal?.containsSEO && {
//         key: 'loginCredentials',
//         name: 'SEO Login Credentials',
//         role: 'PM',
//         dependencies: ['launchCampaigns'],
//       }),
//     }, // TASK FOR CREATING SEO CAMPAIGNS
//     {
//       ...(deal?.isMetaAdvertising ||
//         (true && {
//           key: 'fbAccess',
//           name: 'Meta page Access',
//           role: 'PM',
//           dependencies: ['checklistSent'],
//         })),
//     },

//     { key: 'createAccountShells', name: 'Create Account Shells', role: 'MIA', dependencies: ['verifyDependencies'] }, // TASK FOR CREATING CAMPAIGNS FOR DIGITAL PRODUCTS
//     { key: 'creativeTasksSent', name: 'Creative Tasks Sent', role: 'PM', dependencies: ['verifyDependencies'] },
//     { key: 'integrationsStep', name: 'Integrations', role: 'MIA', dependencies: ['verifyDependencies'] },
//     { key: 'campaignQuality', name: 'Campaign Quality', role: 'DMS', dependencies: ['integrationsStep'] },
//     { key: 'launchCampaigns', name: 'Launch Campaigns', role: 'DMS', dependencies: ['campaignQuality'] },
//     { key: 'handoffCall', name: 'Handoff Call', role: 'PM', dependencies: ['launchCampaigns'] },
//   ]
//   return onboardingChecklist
// }
export const createOnboardingChecklistItem = (deal: OrganizationTableItem) => {
  const list = [
    { key: 'checklistSent', name: 'Checklist Sent (Dependency checklist email)', role: 'PM', dependencies: [] },
    { key: 'receivedDependencies', name: 'Received Dependencies', role: 'PM', dependencies: [] },
    {
      key: 'verifyDependencies',
      name: 'Verify Dependencies',
      role: 'MIA',
      dependencies: [],
    },
    { key: 'gscAccess', name: 'GSC Access', role: 'MIA', dependencies: [] },

    // ✅ return an object OR null (not `{}`)
    deal?.containsSEO ? { key: 'gbpAccess', name: 'GBP Access', role: 'PM', dependencies: [] } : null,

    deal?.containsSEO ? { key: 'completeSeoForm', name: 'SEO Form Completed', role: 'PM', dependencies: [] } : null,

    deal?.containsSEO ? { key: 'loginCredentials', name: 'SEO Login Credentials', role: 'PM', dependencies: [] } : null,

    deal?.isMetaAdvertising ? { key: 'fbAccess', name: 'Meta page Access', role: 'MIA', dependencies: [] } : null,

    { key: 'createAccountShells', name: 'Create Account Shells', role: 'MIA', dependencies: [] },
    { key: 'creativeTasksSent', name: 'Creative Tasks Sent', role: 'PM', dependencies: [] },
    { key: 'integrationsStep', name: 'Integrations', role: 'MIA', dependencies: [] },
    { key: 'campaignReady', name: 'Campaign Creation Ready', role: 'PM', dependencies: [] },
    { key: 'campaignCreation ', name: 'Create Campaigns', role: 'DMS', dependencies: [] },
    { key: 'campaignQuality', name: 'Campaign Quality', role: 'QA', dependencies: [] },
    { key: 'launchCampaigns', name: 'Launch Campaigns', role: 'DMS', dependencies: [] },
    { key: 'handoffCall', name: 'Handoff Call', role: 'PM', dependencies: [] },
  ]

  // ✅ strip nulls
  return list.filter(Boolean)
}
const onboardingChecklist = [
  { key: 'checklistSent', name: 'Checklist Sent (Dependency checklist email)', role: 'PM', dependencies: [] },
  { key: 'receivedDependencies', name: 'Received Dependencies', role: 'PM', dependencies: ['checklistSent'] },
  {
    key: 'verifyDependencies',
    name: 'Verify Dependencies',
    role: 'PM',
    dependencies: ['checklistSent', 'receivedDependencies'],
  },
  { key: 'gscAccess', name: 'GSC Access', role: 'PM', dependencies: ['checklistSent'] },
  { key: 'loginCredentials', name: 'SEO Login Credentials', role: 'PM', dependencies: ['launchCampaigns'] },
  { key: 'createAccountShells', name: 'Create Account Shells', role: 'MIA', dependencies: ['verifyDependencies'] },
  { key: 'creativeTasksSent', name: 'Creative Tasks Sent', role: 'PM', dependencies: ['verifyDependencies'] },
  { key: 'integrationsStep', name: 'Integrations', role: 'MIA', dependencies: ['verifyDependencies'] },
  { key: 'campaignQuality', name: 'Campaign Quality', role: 'DMS', dependencies: ['integrationsStep'] },
  { key: 'launchCampaigns', name: 'Launch Campaigns', role: 'DMS', dependencies: ['campaignQuality'] },
  { key: 'handoffCall', name: 'Handoff Call', role: 'PM', dependencies: ['launchCampaigns'] },
]

const premiumWebsiteList = [
  { key: 'domainAcquisition', name: 'Domain Acquisition', id: 1 },
  { key: 'contentVerification', name: 'Content Verification', id: 2 },
  { key: 'setupDevSite', name: 'Setup Dev Site', id: 3 },
  { key: 'homepageBuild', name: 'Homepage Build', id: 4 },
  { key: 'homepageRevisions', name: 'Homepage Revisions', id: 5 },
  { key: 'subpagesBuild', name: 'Subpages Build', id: 6 },
  { key: 'subpageRevisions', name: 'Subpage Revisions', id: 7 },
  { key: 'qualityAssuranceChecks', name: 'Quality Assurance Checks', id: 8 },
  { key: 'cutoverToLiveDomain', name: 'Cutover to live domain', id: 9 },
]

const newWebsiteList = [
  { key: 'key_1', name: 'Domain Acquisition', id: 1 },
  { key: 'key_2', name: 'Content Verification', id: 2 },
  { key: 'key_3', name: 'Setup Live Domain for Development', id: 3 },
  { key: 'key_4', name: 'Homepage + Coming Soon page Build', id: 4 },
  { key: 'key_5', name: 'Subpage Revisions', id: 5 },
  { key: 'key_6', name: 'Subpages Build', id: 6 },
  { key: 'key_7', name: 'Subpage Revisions', id: 7 },
  { key: 'key_8', name: 'Quality Assurance Checks', id: 8 },
  { key: 'key_9', name: 'Cutover to live domain', id: 9 },
]

// === Registry so you can add more later ===
export const createTaskTemplates = (deal?: OrganizationTableItem) => {
  if (deal) {
    return [
      { id: 'onboarding', label: 'Marketing Onboarding', items: createOnboardingChecklistItem(deal) },
      { id: 'premiumWebsite', label: 'Website – Premium', items: premiumWebsiteList },
      { id: 'newWebsite', label: 'Website – New (Light)', items: newWebsiteList },
    ]
  }
  return [
    { id: 'onboarding', label: 'Marketing Onboarding', items: onboardingChecklist },
    { id: 'premiumWebsite', label: 'Website – Premium', items: premiumWebsiteList },
    { id: 'newWebsite', label: 'Website – New (Light)', items: newWebsiteList },
  ]
}

// export const generateRenderedTaskList = (deal?: OrganizationTableItem) => [
//   { id: 'onboarding', label: 'Marketing Onboarding', items: () => onboardingChecklist(deal) },
//   { id: 'premiumWebsite', label: 'Website – Premium', items: premiumWebsiteList },
//   { id: 'newWebsite', label: 'Website – New (Light)', items: newWebsiteList },
// ]
